import Vue from 'vue'
import {postAction, getAction, uploadAction, deleteAction, putAction, downFilePost} from './api'
// 混合组件
import EasyDataTable from './packages/EasyDataTable/EasyDataTable.vue'
import EasyDataList from './packages/EasyDataList/EasyDataList.vue'
import EasyDataForm from './packages/EasyDataForm/EasyDataForm.vue'
import EasyDataTemplate from './packages/BasicTemplate/EasyDataTemplate.vue'
import EasyDataView from './packages/EasyDataView/EasyDataView.vue'
import EdRichPreview from './packages/EdRichPreview/index.js'
import EdRichText from './packages/EdRichText/index.vue'

// 装载组件
import DataSourceList from './pages/DataSource'
import Interface from './pages/Interface'
import Template from './pages/Template'

// css
import "./style/index.scss"

// 组件集合
const components = {
  EasyDataList,
  EasyDataTable,
  EasyDataForm,
  EasyDataTemplate,
  EasyDataView,
  EdRichPreview,
  EdRichText,

  DataSourceList,
  Interface,
  Template,
}

Object.keys(components).forEach(key => {
  Vue.component(components[key].name, components[key]);
});


const install = function (Vue, opts = {}) {
  // 传递参数
  Vue.prototype.$EdFrame = {}
  Object.keys(opts).forEach(key => {
    Vue.prototype.$EdFrame[key] = opts[key]
  });

  // 注册请求方法 - post
  Vue.prototype.$EdFrame.postAction = postAction
  Vue.prototype.$EdFrame.getAction = getAction
  Vue.prototype.$EdFrame.uploadAction = uploadAction
  Vue.prototype.$EdFrame.deleteAction = deleteAction
  Vue.prototype.$EdFrame.putAction = putAction
  Vue.prototype.$EdFrame.downFilePost = downFilePost
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  EasyDataTemplate,
  EasyDataView,
  EasyDataList,
  EasyDataTable,

  DataSourceList,
  Interface,
  Template,
}

export default {
  version: '1.0.0',
  install,
}





